import { useEffect } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from '../../Root';
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { Alert, Box, Link, Divider } from '@mui/material';
import { useMassExpedient } from './hooks/useMassExpedient';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SnackbarContent from '@mui/material/SnackbarContent';
import alert from '../../../images/alert.png'


export type addFeatureInextProps = {
    open: boolean;
    data?: any;
    changeAlert: ChangeAlertCallbackType;
    changeLoader: ChangeLoaderCallbackType;
}

export const MassExpedientDownload = ({ open, data, changeAlert, changeLoader }: addFeatureInextProps & DefaultComponentProps) => {
    const { form, zPos, loading: loadingTable, isValidForm, dropZoneRef, failedData, onFormReset, onConfirm, onSelectFile, handleOver, handleLeave, handleDrop, onClose} = useMassExpedient(open, data, changeAlert);

    const addFile = () => {
        document.getElementById("file").click();
    };
    const action = (
        <Button size="small" style={{backgroundColor: "transparent", borderColor: "transparent", textAlign: "right"}} onClick={onFormReset}>Cambiar</Button>
    );

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    return (
        <Dialog onClose={onClose} open={open} style={{ display: zPos !== 45 ? "none" : null, minWidth: "600px", maxHeight: "600px" }}>
            <DialogTitle>
                <Typography variant='h2'>Descarga Masiva de Expedientes</Typography>
            </DialogTitle>

            <DialogContent style={{paddingTop: 30}}>
                { !form && <Alert severity={"info"}>
                    A continuación, seleccione el archivo con los UUID de los Clientes.
                </Alert>}

                { !failedData && (form && form["lines"] ?
                    <Box sx={{mb: 1, textAlign: "center"}} display={"flex"}>
                        <Box component="img" alignSelf={"center"} alt="emptyList" src={alert} width={150}/>
                        <Box py={3} pl={2} alignContent={"center"}>
                            <SnackbarContent message={form["file_name"]} action={action} sx={{backgroundColor: "cadetblue", mb: 3, fontWeight: 800}} />
                            <Typography variant="paragraph">Realizarás la descarga de <b>{form["lines"].length} expedientes. </b></Typography>
                            <Typography variant="paragraph">¿Deseas continuar?</Typography>
                        </Box>
                    </Box> 
                    :
                    <>
                    <Box 
                        ref={dropZoneRef} onDragLeave={handleLeave} onDragOver={handleOver} onDrop={handleDrop} onClick={addFile.bind(this, "")}
                        sx={{p: 3, mb: 1, mt: 3, border: "4px dashed lightgray", textAlign: "center", cursor: "pointer"}}>
                        <CloudUploadIcon fontSize="large" color="action" sx={{m: 1}} style={{display: "block", justifySelf: "center"}}/>
                        <Typography variant="paragraph">
                            Arrastra y suelta tu archivo o <Link >cárgalo desde tus documentos</Link>
                        </Typography>
                        <input id="file" type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style={{ display: "none" }} onChange={onSelectFile.bind(this)}/>
                    </Box>
                    <Typography variant="paragraph">Formatos válidos: .csv .xls y .xlsx.</Typography>
                    </>
                )}
                { failedData && 
                    <Box sx={{mb: 1, textAlign: "center"}} display={"block"}>
                        <div id="subtitle_2">Ocurrió un error con la generación de {failedData.length} Expedientes. Genera un nuevo archivo con éste listado, e intenta nuevamente.</div>
					    <Divider sx={{ my: 2}} />
                            { failedData.map((i) => 
                                <Box key={i} alignContent={"center"}>
                                    <Typography variant="paragraph">{i}</Typography>
                                </Box>
                            )}
                    </Box>
                }
            </DialogContent>

            <DialogActions>
                <FlexGrid fullHeight fullWidth justify='space-between' alignItems='space-between' style={{ marginTop: '20px', display: 'flex' }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{textAlign: 'end'}}>
                        <Button onClick={onConfirm.bind(this, form["lines"])} disabled={isValidForm} size='normal'>
                            Ejecutar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}

export default MassExpedientDownload;
